import 'angular';

angular.module('GorillaBoy')
.directive('pdfViewer', () => {
    return {
        restrict : 'E',
        scope: {
            url : '<',
        },
        template: `<iframe src="{{url}}" width="100%" height="100%"></iframe>`,
        link : ($scope, $element) => {
            //We need to pass some configuration to the bridge to make it behave like view only
            const documentViewerBridge = new (window as any).DocViewerBridge(window);
            $scope.$on('$destroy', function() {
                //VERY IMPORTANT: the corressponding bridge layer for this document load has to be destroyed.
                documentViewerBridge.destroy();
            });

            $scope.$watch('url', () => {
                const iFrameEl : HTMLIFrameElement = $element.find('iframe').get(0);
                if (iFrameEl.contentWindow) {
                    documentViewerBridge.init(iFrameEl.contentWindow);
                    documentViewerBridge.updateConfiguration({
                        isViewer: true
                    });
                }
            });
        }
    };
});
